/**
 * Requires
 */

import $ from 'jquery'

/**
 * Initialisation
 */

export function initialise() {

    function setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = "expires="+d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    function getCookie(cname) {
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for(var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    function checkCookie() {
        var acknowledgment = getCookie("acknowledgment?v=2");
        if (acknowledgment !== "") {
            // Cookie exists do nothing
            console.log("cookie exists")
        } else {
            console.log('no cookie')
            $('.acknowledgment').show().delay(2500).fadeOut();
            setCookie("acknowledgment?v=2", "yes", 1);
        }
    }


    checkCookie()

}
